/**
 *
 * Created by Filipe - 07/10/2020
 *
 */

export function convert2FriendlyCat(value){
    value = value.toLowerCase()
    value = value.replace(/[\s]/g, '-')
    value = value.replace(/[áàâã]/g, 'a')
    value = value.replace(/[éèê]/g, 'e')
    value = value.replace(/[íìî]/g, 'i')
    value = value.replace(/[óòõô]/g, 'o')
    value = value.replace(/[úùû]/g, 'u')
    value = value.replace(/[ñ]/g, 'n')
    value = value.replace(/[ç]/g, 'c')
    value = value.replace(/[^a-z0-9\-]/g, '')//final clean, just in case...
    return value
}


